// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: window["env"]["production"],
  appVersion: '1.0.0',
  isMockEnabled: true,
  apiUrl: 'api',
  
  oktaConfig : {
    issuer:  window["env"]["oktaIssuer"],
    clientId: window["env"]["oktaClientId"],
    redirectUri: window["env"]["oktaRedirectUri"],
    postLogoutRedirectUri: window["env"]["oktaPostLogoutRedirectUri"],
    pkce: true
  },

  synchronizerService: {
    url: '/synchronizerService/',
  },
  standalone: window["env"]["standalone"],

  applicationInsights: {
      instrumentationKey: window["env"]["applicationInsights_instrumentationKey"]
  },
  topdeskUrl: 'https://elis.topdesk.net/tas/public/ssp/content/serviceflow?unid=a7034b8f089f45d3bbd10145bec63454&from=94a91f46-838b-408c-a79a-78653f08c58c'

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
